import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/basicInfo';
const expertInfo: Array<RouteConfig> = [
    {
        path: 'data-manage/gov-info',
        name: 'govInfo',
        redirect: { name: 'govPrincipal' },
        meta: {
            menuMatch: 'govPrincipal',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'gov-principal',
                name: 'govPrincipal',
                component: () => import(`@/${BASE_PATH}/Principal.vue`),
                meta: {
                    index: '3-1',
                    isGov:true
                },
            },
            {
                path: 'gov-organization',
                name: 'govOrganization',
                component: () => import(`@/${BASE_PATH}/Organization.vue`),
                meta: {
                    index: '3-2',
                },
            },
            {
                path: 'gov-personnel',
                name: 'govPersonnel',
                component: () => import(`@/${BASE_PATH}/personnel/Personnel.vue`),
                meta: {
                    index: '3-3',
                },
            },
            {
                path: 'gov-permissions',
                name: 'govPermissions',
                component: () => import(`@/${BASE_PATH}/permissions/Permissions.vue`),
                meta: {
                    index: '3-4',
                    subPage:'govPermissionsDetail'
                },
            },
            {
                path: 'gov-permissions-detail',
                name: 'govPermissionsDetail',
                component: () => import(`@/${BASE_PATH}/permissions/PermissionsDetail.vue`),
                meta: {
                    index: '3-4',
                    supPage:'gov-permissions'
                },
            },
        ],
    },
];
export default expertInfo;